import {Component, HostBinding, OnInit} from '@angular/core';
import {navigationItems} from '@catapp/modules/base-app/app.navigation';
import {UserService} from '@catcore/services/user.service';
import {CatUser} from "@catcore/types/api-v2";
import {ClientVersionService} from "@catcore/services/client-version.service";
import {NotificationsService} from "@catcore/services";
import {WebclientVersion} from "@catmodules/base-app/app.types";
import {Subscription} from "rxjs";
const { version: appVersion } = require('../../../../../../package.json');

const componentBaseName = 'navigation';
const defaultClassNames = ['cat-' + componentBaseName + '-component'];

@Component({
  selector: 'cat-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  @HostBinding('class') classNames = defaultClassNames.join(' ');

  navigationItems = navigationItems;
  user: CatUser = null;
  version: string = appVersion;

  private versionSubscription: Subscription;

  constructor(private userService: UserService,
              private clientVersionService: ClientVersionService,
              private notificationService: NotificationsService) {
  }

  ngOnInit() {
      this.userService.getUser().subscribe((user: CatUser) => {
          this.user = user;
      });
      this.userService.refresh();

      this.checkClientVersion();
  }

  ngOnDestroy() {
    this.versionSubscription.unsubscribe();
  }

  logoutUser() {
      this.userService.logout();
  }

  checkClientVersion() {
    if (this.versionSubscription) {
      this.versionSubscription.unsubscribe();
    }
    this.versionSubscription = this.clientVersionService
      .getCurrentVersion()
      .subscribe((clientVersion: WebclientVersion) => {
        if (clientVersion.version
          && clientVersion.version !== this.version) {
          this.notificationService.warn(
            'New Version Available',
            'A new version of the webclient is available (' + clientVersion.version  + '). Please do a full refresh of this website.'
          );
        }
      })
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/base-app/components/navigation/navigation.component.ts